interface HeaderProps {
  onSignOut: () => void;
}

export default function Header({ onSignOut }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-brand">
        <span className="header-logo" aria-hidden="true">
          &#9729;
        </span>
        <h1 className="header-title">AWS GenAI Chat</h1>
      </div>
      <button
        className="header-sign-out"
        onClick={onSignOut}
        aria-label="Sign out"
        type="button"
      >
        Sign Out
      </button>
    </header>
  );
}
